<template>
  <div>
    <div class="topDiv">
      <!-- <span v-if="contractStatus === '7'">此合同已通过审批，是否打印并增加“公司名称”水印？</span>
      <span v-else>此合同未通过审批，是否打印并增加“草稿”水印？</span> -->
      <el-button @click="goBack">取 消</el-button>
      <el-button type="primary" v-print="printObj" @click="addPrint">打印</el-button>
    </div>
    <div class="printDiv">
      <div id="printContract" class="printContract">
        <div ref="watermarkRef" class="watermarkRef">
          <div class="ql-editor" v-html="content"></div>
          <div class="title">《租金价目表》（人民币）</div>
          <el-table v-loading="loading" :data="previewTableData" :cell-style="{'text-align':'left'}"
            :default-sort="{prop: 'id', order: 'descending'}" border :highlight-current-row="false">
            <template v-for="(item, index) in previewTableColumns">
              <el-table-column :key="index" :prop="item.prop" :label="item.label" :width="item.width"></el-table-column>
            </template>
          </el-table>
          <div class="content">
            <div class="word">1.本价目表中的租金总额以租赁面积 {{ contractRentalRelationArea }} 平方米为前提计算。租金计算公式为房屋建筑面积*日租金*365天。</div>
            <div class="word">2.本价目表信息一经提交，无法修改，请慎重计算！</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { previewContractDetail, addPrint } from '@/api/contract'
// import waterMarkComp from '@/utils/waterMark'
import Watermark from '@/utils/watermark'

export default {
  name: 'previewContract',
  data () {
    return {
      loading: false,
      printObj: {
        id: 'printContract',
        popTitle: 'ceshi',
        extraHead: '<meta http-equiv="Content-Language"content="zh-cn"/>',
        openCallback (e) {
          console.log('执行了打印', e)
        }
      },

      id: this.$route.query.id,
      contractNumber: this.$route.query.contractNumber,
      contractStatus: this.$route.query.contractStatus,
      companyName: this.$route.query.companyName,
      // 预览的表格数据
      previewTableData: [],
      previewTableColumns: [
        // {
        //   prop: 'id',
        //   label: '项目',
        //   width: '60px'
        // },
        {
          prop: 'rentalDate',
          label: '租赁期限',
          width: '210px'
        },
        {
          prop: 'rentalUnit',
          label: '每期租金（元）',
          width: '100px'
        },
        {
          prop: 'rentalSum',
          label: '租金总额（元）',
          width: '100px'
        },
        {
          prop: 'dailyRental',
          label: '日租金（元/天/平米）',
          width: '120px'
        },
        // {
        //   prop: 'manageFee',
        //   label: '物业管理费（元）',
        //   width: '80px'
        // },
        {
          prop: 'remark',
          label: '备注',
          width: '118px'
        }
      ],
      contractRentalRelationArea: '', // 预览最后的租赁面积参数
      content: '' // 预览内容
    }
  },
  components: {
    // waterMarkComp
  },
  mounted () {
    this.editData()
    // 设置页面水印
    if (this.contractStatus === '7') {
      let img = document.createElement('img')
      img.width = 30
      img.height = 30
      img.src = './xinda-logo.png'
      img.onload = () => {
        Watermark.set(img, this.$refs.watermarkRef)
      }
      // Watermark.set(this.companyName, this.$refs.watermarkRef)
    } else {
    }
    Watermark.set('鑫达', this.$refs.watermarkRef)
  },
  methods: {
    // 编辑接口 预览
    async editData () {
      // 预览接口，获得合同预览内容
      let res = await previewContractDetail({
        id: this.id
      })
      if (res.code === 0) {
        let previewTableDataNew = []
        this.previewVisible = true
        this.content = res.result.contractFormatContent
        res.result.contractRentalRelationList.forEach((item) => {
          previewTableDataNew.push({
            id: item.id,
            rentalDate: item.rentalStartDate + '~' + item.rentalEndDate,
            rentalUnit: item.rentalUnit,
            rentalSum: item.rentalSum,
            dailyRental: item.dailyRental,
            manageFee: item.manageFee,
            remark: item.remark
          })
        })
        this.previewTableData = previewTableDataNew
        this.contractRentalRelationArea = res.result.contractRentalRelationArea
      }
    },
    // 确认打印
    // isPrintDiv () {
    //   this.$print(this.$refs.printDiv)
    // },
    // 取消
    goBack () {
      this.$router.push('/contract/management')
    },
    async addPrint () {
      let res = await addPrint({ contractNumber: this.contractNumber })
      if (res.code === 0) {
        this.$message({
          type: 'success',
          message: '打印'
        })
      } else {
        this.$message({
          type: 'warning',
          message: res.message
        })
      }
    }
  }
}
</script>

<style lang="scss">
.topDiv {
  width: 10rem;
  margin: .2rem auto;
  font-size: .16rem;
}
.printDiv {
  width: 10rem;
  margin: 0 auto;
  background-color: #fff;
}
.printContract {
  width: 100%;
  background-color: #fff;
}
.watermarkRef {
  position: absolute;
  width: 100%;
  height: 100%;
  background: transparent;
}
/deep/ .el-table td {
  text-align: left !important
}
.el-table--border .el-table__cell {
  border-right: 3px solid #dfe6ec !important;
  border-bottom: 3px solid #dfe6ec !important;
}
.el-table--border {
  margin: 0 auto;
  border: 3px solid #dfe6ec;
  border-right: none;
  border-bottom: none;
}
.el-table {
  z-index: inherit
}
.el-table--fit {
  width: 651px;
}
/deep/ .el-table--group::after, .el-table--border::after, .el-table::before {
  background-color: transparent;
}
/*/deep/.el-table--group::after, .el-table--border::after, .el-table::before{*/
/*  background-color: transparent;*/
/*}*/
/*/deep/.el-table--boder th.gutter:last-of-type {*/
/*  display: block !important*/
/*}*/
.quillEdit {
  height: 6.5rem;
  width: 12rem;
  margin-right: 0;
  margin-top: .1rem;
  float: right;
}
.ql-lineheight {
  width: 70px;
}
.ql-lineheight-1 {
  line-height: 1;
}
.ql-lineheight-1-5 {
  line-height: 1.5;
}
.ql-lineheight-1-75 {
  line-height: 1.75;
}
.ql-lineheight-2 {
  line-height: 2;
}
.ql-lineheight-3 {
  line-height: 3;
}
.ql-lineheight-4 {
  line-height: 4;
}
.ql-lineheight-5 {
  line-height: 5;
}
</style>
